'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as FoldersActions from 'DesignData/actions/finder/Folders';
import * as OptionsActions from 'DesignData/actions/finder/Options';
import { FolderPropTypes } from 'DesignData/propTypes/finder';
import * as finderSelectors from 'DesignData/selectors/finder';
/**
 * High Order Component connecting folders to Redux store
 */

export default function withConnectedFolder(WrappedComponent) {
  class HighOrderConnectedFolder extends Component {
    constructor(props) {
      super(props);
      this.duplicateFolder = this.duplicateFolder.bind(this);
      this.renameFolder = this.renameFolder.bind(this);
      this.toggleRenameFolder = this.toggleRenameFolder.bind(this);
    }

    duplicateFolder() {
      const {
        folder,
        parentFolderId
      } = this.props;
      this.props.duplicateFolder(folder, parentFolderId);
    }

    renameFolder(folderName) {
      this.props.renameFolder(this.props.folderId, folderName);
    }

    toggleRenameFolder() {
      this.props.toggleRenameAsset(this.props.folderId);
    }

    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        duplicateFolder: this.duplicateFolder,
        renameFolder: this.renameFolder,
        toggleRenameFolder: this.toggleRenameFolder
      }));
    }

  }
  /**
   * Statics
   */


  HighOrderConnectedFolder.propTypes = {
    duplicateFolder: PropTypes.func.isRequired,
    folder: FolderPropTypes.folder,
    folderId: FolderPropTypes.folderId,
    folderName: FolderPropTypes.folderName,
    folderPermissions: FolderPropTypes.folderPermissions,
    folderSubcategory: FolderPropTypes.folderSubcategory,
    isRenamingFolder: FolderPropTypes.isRenamingFolder,
    isUserFolder: FolderPropTypes.isUserFolder,
    parentFolderId: FolderPropTypes.folderId,
    renameFolder: PropTypes.func.isRequired,
    toggleRenameAsset: PropTypes.func.isRequired
  };
  /**
   * Connect
   */

  function makeMapStateToProps() {
    const getFolderProps = finderSelectors.makeGetFolderProps();
    return function mapStateToProps(state, props) {
      return getFolderProps(state, props);
    };
  }

  const mapDispatchToProps = {
    duplicateFolder: FoldersActions.duplicateFolder,
    hideRenameConfirm: OptionsActions.hideRenameFolderConfirm,
    renameFolder: FoldersActions.renameFolder,
    toggleRenameAsset: OptionsActions.toggleRenameAsset
  };
  return connect(makeMapStateToProps, mapDispatchToProps)(HighOrderConnectedFolder);
}